import React, { Component } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ContactCard } from 'advenio-components'

const InventorySection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
`
const PanelHeader = styled.div`
  color: #9B9B9B;
  margin: 4px;
  width: 100%;
  text-align: left;
`
const Icon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 4px;
`

const InventoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: 2vh 0 0 0;
`
const PanelSection = styled.div`
  display: flex;
  min-height: 10vh;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px;
  border-bottom: ${props => props.border ? 'solid 1px' : ''};
  border-bottom-color: #CCCCCC;
  border-top: ${props => props.top ? 'solid 1px' : ''};
  border-top-color: #CCCCCC;
  flex-direction: column;
`
const DivWithIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`
const SectionName = styled.span`
  font-size: 14px;
  color:#a0a0a0;
  font-weight: bold;
`
const StyledSpan = styled.span`
  font-size: 12px;
`

const ParentLabel = styled.div`
  display: flex;
  justify-content: space-between;
  flex:1;
  background-color: #E2E8EC;
  border-radius: 4px;
  width: 100%;
  margin: 8px 0 8px 0;
`

const ParentName = styled.span`
  color:red;
  font-size: 14px;
  margin:8px;
`
const ParentRealtion = styled.span`
  color:#a0a0a0;
  font-size: 14px;
  margin:8px;
`

const CloudBar = styled.div`
  display: ${props => props.isCloud ? 'flex' : 'none'};
  background-color: #f0f9fe;
  color:#4A4A4A;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-size: 12px;
`

const CloudIcon = styled.img`
  margin: 0 4px 0 4px;
`

const AlergiasEmptyState = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  opacity: .5;
`

class ProfileMobile extends Component {
  formatHoursConsumed = (time) => {
    const [hours, minutes] = time.split(':')

    return `${hours}h ${minutes}m`
  }

  render() {
    const { profile, user } = this.props

    return (
      <div>
        <CloudBar isCloud={profile.checkin.is_virtual_center}>
          <CloudIcon src="/assets/cloud_blue.svg" />
          <span>{`${profile.first_name} nos visita desde ${profile.center.name}`}</span>
        </CloudBar>

        <PanelSection top>
          <PanelHeader>INFORMACIÓN</PanelHeader>
          <InventoryRow>
            <DivWithIcon>
              <Icon src="/assets/office.svg" alt="clock" />
              <StyledSpan>
                Empresa y Convenio
              </StyledSpan>
            </DivWithIcon>
            <StyledSpan right>
              {profile.product.type === 'ContractProduct' ?
                `${profile.center.name}::${profile.product.contract.name}`
                : 'Sin Convenio'}
            </StyledSpan>
          </InventoryRow>
          <InventoryRow>
            <DivWithIcon>
              <Icon src="/assets/cake.svg" alt="diaper" />
              <StyledSpan>
                Fecha de Nacimiento
              </StyledSpan>
            </DivWithIcon>
            <StyledSpan right>
              {profile.birth_date && moment(profile.birth_date).format('DD MMM YYYY')}
            </StyledSpan>
          </InventoryRow>
          <InventoryRow>
            <DivWithIcon>
              <Icon src="/assets/info_icon.svg" alt="clock" />
              <StyledSpan>
                Producto
              </StyledSpan>
            </DivWithIcon>
            <StyledSpan>
              {profile.product.type === 'ContractProduct' ?
                profile.product.contract.contract_type
                : profile.product.product_details.product.name}
            </StyledSpan>
          </InventoryRow>

          {profile.product.type === 'CenterProduct' &&
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/clock_icon.svg" alt="hours" />
                <StyledSpan>
                  Horas Consumidas
                </StyledSpan>
              </DivWithIcon>
              <StyledSpan>
                {this.formatHoursConsumed(profile.product.hours_consumed)}
              </StyledSpan>
            </InventoryRow>}
        </PanelSection>

        <PanelSection border top>
          <InventorySection>
            <SectionName>ALERGIAS</SectionName>
            <AlergiasEmptyState>
              <span>No tiene alergias</span>
            </AlergiasEmptyState>
          </InventorySection>
        </PanelSection>
        <PanelSection >
          <SectionName>PAPÁS</SectionName>
          {profile.parents && profile.parents.map(parent => (
            <ContactCard
              key={parent.id}
              name={`${parent.first_name} ${parent.last_name_paternal}`}
              email={user.user_type === 'Center Operation' ? parent.email : undefined}
              phone={user.user_type === 'Center Operation' ? parent.phone : undefined}
              onClick={() => null}
              withoutArrow={false}
            />
          ))}
        </PanelSection>
      </div>)
  }
}

ProfileMobile.propTypes = {
  profile: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

export default ProfileMobile



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/ProfileMobile.jsx